// extracted by mini-css-extract-plugin
module.exports = {"base":"sixStories1AdWithTagSearch-m__base__2TH9V","wrapper":"sixStories1AdWithTagSearch-m__wrapper__1inOQ"};